module.exports = __webpack_public_path__ + "img/banner_patrol.f14642a1.jpg";